import { Fade, Stack, styled } from "@mui/material";
import { optionalClassName } from "@smartrr/shared/components/primitives";
import { AquariusButton } from "@smartrr/shared/customerPortal/components/AquariusButton";
import { Check, SettingsHorizontal } from "akar-icons";
import kebabCase from 'lodash/kebabCase';
import React from "react";

import { FilterTagRowProp } from "../../types";

const FilterPill = styled(AquariusButton)`
  gap: 5px;
  height: 20px;
  margin: 0;
  min-width: auto;
  padding: 2px 10px;
  text-wrap: nowrap;
  width: max-content;
`;

export const FilterTagRow = ({ onTagSelect, tags, activeTag }: FilterTagRowProp) => {
  if (!tags.length || !tags) {
    return <React.Fragment />;
  }

  return (
    <Stack direction="row" gap="7px" alignItems="center" mt="15px" data-testid="filter-pill-row">
      <SettingsHorizontal strokeWidth={2} size={14} />
      <Stack
        width="100%"
        overflow="scroll"
        direction="row"
        gap="7px"
        sx={{
          overflowX: "scroll",
          overflowY: "hidden",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {tags.sort().map(tag => {
          const isActive = tag === activeTag;
          const classNames = optionalClassName({
            "active-filter-pill": isActive,
            "filter-pill": true,
          });

          return (
            <FilterPill
              data-testid="filter-pill"
              id={`filter-pill-${kebabCase(tag.toLocaleLowerCase())}`}
              key={tag}
              className={classNames}
              filled={isActive}
              onClick={() => onTagSelect(isActive ? undefined : tag)}
              sx={{
                gap: isActive ? "5px" : "0",
                transition: "gap .15s ease-in-out",
              }}
            >
              <Fade in={isActive} timeout={{ enter: 200, exit: 0 }} unmountOnExit mountOnEnter>
                <div>
                  <Check strokeWidth={2} size={11} />
                </div>
              </Fade>

              {tag}
            </FilterPill>
          );
        })}
      </Stack>
    </Stack>
  );
};
